import {packSession} from '../session/sessionAPI'
import {createSetlistZip} from '../../factories/Zipper';
import { triggerBlobDownload } from '../../factories/ui';

// pgw doc 04-aug-2025 - packSetlist
export const packSetlist = async (sessions) => {

  // create a zip of each session
  const sessionZips = {};

  for (const session of sessions) {
    sessionZips[session.id] = await packSession(session);
  }

  // Cretae new zip file
  const setListZip = await createSetlistZip(sessionZips);

  return setListZip;
    
}

// pgw doc 04-aug-2025 - generateShortLink
// Generates link for sharing
// Called from here:
// bb $devdir/player-application/src/containers/SetList/index.js

export async function generateShortLink(endpoint, long_url) {
  const response = await fetch(endpoint, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      long_url
    })
  });
  if (response.status === 200) {
    const result = await response.json();
    return result.link;
  } else {
      throw new Error("Error fetching short link");
  }
}
